import * as React from 'react';

var useOutsideClickClose = function useOutsideClickClose(handleClose) {
  var disabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var wrapperRef = React.useRef(null);
  var handleOutsideClick = function handleOutsideClick(e) {
    // istanbul ignore else
    if (e.target instanceof Node && wrapperRef.current && !wrapperRef.current.contains(e.target)) {
      handleClose();
    }
  };
  React.useEffect(function () {
    if (!disabled) {
      document.addEventListener('mousedown', handleOutsideClick);
      document.addEventListener('focus', handleOutsideClick, true);
    }
    return function () {
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('focus', handleOutsideClick);
    };
  }, [disabled]);
  return {
    wrapperRef: wrapperRef
  };
};

export { useOutsideClickClose };
